<template>
    <v-layout wrap class="px-3 flex-column">
        <div class="my-3 scan-header">SCAN SETUP</div>
        <v-row>
            <v-col cols="12" v-if="getLoadingStatus && isAdmin">
                <div class="d-flex fill-height align-center justify-center">
                    <Spinner />
                </div>
            </v-col>
            <v-col cols="12" class="pa-0">
                <Confirm showCancelBtn
                         :dialog="dialog"
                         :confirmMsg="'Are you sure?'"
                         :confirmBody="'You are deleting a scan ' + this.confirmBody + '. This action can not be undone.'"
                         @hide-confirm="handleConfirm"/>
            </v-col>
            <v-col cols="12" class="mt-3" v-if="!getLoadingStatus && isComplianceAvailable">
                <div>
                    <v-chip
                            outlined
                            color="green"
                            class="mr-2"
                            v-if="complianceLevel === 'write'"
                    >
                        <v-avatar
                                left
                                class="green lighten-4"
                                color="white"
                        >
                            {{ complianceLimit }}
                        </v-avatar>
                        Compliance limit left
                    </v-chip>
                </div>
                <Button
                        v-on:onClick="changeScan('+ Compliance scan')"
                        class="mb-3 mt-3"
                        :content="`+ Compliance scan`"
                        depressed
                        :disabled="isDisabledAddComplianceScan"
                />
                <Table :data="getScenarioScanList"
                       :canBeScanned="true"
                       :routerName="'EditScenarioScan'"
                       :domainType="'scenario'"
                       @delete-scan="deleteScan"
                       @change-items-per-page="handleItemsPerPage"
                       @change-pagination="handlePagination"
                       @change-search="handleSearch"
                       :loading="loadingFetchScenarioScanList"
                       :selectedScan="selectedScan"
                       :type="'compliance'"
                       :permissions="getPermissions"
                       :complianceEdit="complianceEdit"
                />
            </v-col>
            <v-col cols="12" v-if="false" >
<!--              v-if="isAdmin && !getLoadingStatus && (isScheduledPerformanceAvailable || isScheduledAdsAvailable)"-->
              <div>
                    <v-chip
                            outlined
                            color="green"
                            class="mr-2"
                            v-if="scheduledPerformanceLevel === 'write'"
                    >
                        <v-avatar
                                left
                                class="green lighten-4"
                                color="white"
                        >
                            {{ scheduledPerformanceLimit }}
                        </v-avatar>
                        Performance limit left
                    </v-chip>
                    <v-chip
                            outlined
                            color="green"
                            class="mr-2"
                            v-if="scheduledAdsLevel === 'write'"
                    >
                        <v-avatar
                                left
                                class="green lighten-4"
                                color="white"
                        >
                            {{ scheduledAdsLimit }}
                        </v-avatar>
                        Ads limit left
                    </v-chip>
                </div>
                <Button
                        v-on:onClick="changeScan('+ Performance scan')"
                        class="mb-3 mt-3"
                        :content="`+ Performance scan`"
                        depressed
                        :disabled="isDisabledAddScheduledScan"
                />
                <Table :data="getScheduledScanList"
                       :canBeScanned="true"
                       :routerName="'EditScheduledScan'"
                       :domainType="'screenshots'"
                       @delete-scan="deleteScan"
                       @change-items-per-page="handleItemsPerPage"
                       @change-pagination="handlePagination"
                       @change-search="handleSearch"
                       :loading="loadingFetchScheduledScanList"
                       :selectedScan="selectedScan"
                       :type="'performance.scheduled'"
                       :permissions="getPermissions"
                       :scheduledPerformanceEdit="scheduledPerformanceEdit"
                       :scheduledAdsEdit="scheduledAdsEdit"
                />
            </v-col>
            <v-col cols="12" class="mt-3" v-if="false">
<!--              v-if="!getLoadingStatus && (isRealtimePerformanceAvailable || isRealtimeAdsAvailable)"-->
                <div>
                    <v-chip
                            outlined
                            color="green"
                            class="mr-2"
                            v-if="realtimePerformanceLevel === 'write'"
                    >
                        <v-avatar
                                left
                                class="green lighten-4"
                                color="white"
                        >
                            {{ realtimePerformanceLimit }}
                        </v-avatar>
                        Performance limit left
                    </v-chip>
                    <v-chip
                            outlined
                            color="green"
                            class="mr-2"
                            v-if="realtimeAdsLevel === 'write'"
                    >
                        <v-avatar
                                left
                                class="green lighten-4"
                                color="white"
                        >
                            {{ realtimeAdsLimit }}
                        </v-avatar>
                        Ads limit left
                    </v-chip>
                </div>
                <Button
                        v-on:onClick="changeScan('+ Realtime scan')"
                        class="mb-3 mt-3"
                        :content="`+ Realtime scan`"
                        depressed
                        :disabled="isDisabledAddRealtimeScan"

                />
                <Table :data="getRealTimeScanList"
                       :type="'performance.realtime'"
                       :permissions="getPermissions"
                       :realtimePerformanceEdit="realtimePerformanceEdit"
                       :realtimeAdsEdit="realtimeAdsEdit"
                       @change-items-per-page="handleItemsPerPage"
                       @change-pagination="handlePagination"
                       @change-search="handleSearch"
                       :loading="loadingFetchRealTimeScanList"
                />
            </v-col>
<!--            TODO uncomment next table as soon as we have data for them-->
<!--            <v-col cols="12" class="mt-3" v-if="hasVNC">-->
<!--                <Table :data="getRealTimeScanVNCList" />-->
<!--            </v-col>-->
        </v-row>
    </v-layout>
</template>

<script>
    import Table from "../components/common/Table";
    import Button from "../components/common/Button";
    import Spinner from "../components/common/Spinner";
    import { createNamespacedHelpers, mapGetters } from "vuex";
    import asyncDataStatus from "../mixins/asyncDataStatus";
    import Confirm from "../components/common/Confirm";
    import {
        REALTIME_SCAN,
        REALTIME_SCAN_LANDING,
    } from "../utils/routes";
    const authHelper = createNamespacedHelpers("auth");
    const scanListHelper = createNamespacedHelpers("scanList");
    export default {
        name: "ScanList",
        components: {Spinner, Table, Confirm, Button },
        mixins: [asyncDataStatus],
        computed: {
            ...mapGetters(["getLoadingStatus"]),
            ...authHelper.mapGetters(["getSelectedClient", "hasVNC", "isAdmin", "getPermissions"]),
            ...scanListHelper.mapGetters([
                "getScheduledScanList",
                "getRealTimeScanList",
                "getRealTimeScanVNCList",
                "getScenarioScanList",
            ])
        },
        methods: {
            ...scanListHelper.mapActions(["fetchScanListTableData", "deleteScheduledScan","deleteScenarioScan", "fetchScheduledScanList", "fetchScenarioScanList", "fetchRealTimeScanList"]),
            ...authHelper.mapActions(["fetchPermissions"]),
            async loadScanListTableData() {
                try {
                    await this.loadingStart();
                    await this.fetchPermissions(this.getSelectedClient);
                    await this.fetchScanListTableData({
                        client: this.getSelectedClient,
                        page: 1,
                        page_size: 10,
                        search_website_name: '',
                        search_scan_name: ''
                    });
                    await this.loadingEnd();
                } catch (e) {
                    alert(e.response ? e.response.data.detail[0]: e);
                }
                this.isScheduledPerformanceAvailable = false;
                this.isScheduledAdsAvailable = false;
                this.isRealtimePerformanceAvailable = false;
                this.isRealtimeAdsAvailable =false;
                this.isComplianceAvailable = false;
                this.getPermissions.forEach(p=>{
                    if(p.level !== 'zeroed'){
                        p.name === 'general.performance.scheduled.scan' && ( this.isScheduledPerformanceAvailable = true);
                        p.name === 'general.performance.scheduled.ads' && (this.isScheduledAdsAvailable = true);
                        p.name === 'general.performance.realtime.scan' && (this.isRealtimePerformanceAvailable = true);
                        p.name === 'general.performance.realtime.ads' && (this.isRealtimeAdsAvailable = true);
                        p.name === 'general.compliance.scheduled_scan' && (this.isComplianceAvailable = true);
                    }
                });
            },
            async handleConfirm(answer){
                this.dialog = false;
                if(answer){
                    try {
                        if(this.domainType === 'scenario'){
                            await this.deleteScenarioScan(this.selectedScan);
                        } else {
                            await this.deleteScheduledScan(this.selectedScan);
                        }
                        this.fetchPermissions(this.getSelectedClient);
                    }catch(e){
                        alert(e)
                    }
                }
            },
            deleteScan(item, domainType){
                this.domainType = domainType;
                this.scan = item;
                this.selectedScan = item.id;
                this.dialog = true;
            },
            changeScan(scanName) {
                if(scanName === '+ Realtime scan'){
                    this.$router.push(`${REALTIME_SCAN_LANDING.path}${REALTIME_SCAN.path}`);
                } else if(scanName === '+ Performance scan'){
                    this.$router.push('scheduled-scan');
                } else if(scanName === '+ Compliance scan'){
                    this.$router.push('scenario-scan');
                }
            },
            async handleItemsPerPage(itemsPerPage, type, pageNumber, search){
                if(type === 'performance.scheduled'){
                    this.loadingFetchScheduledScanList = true;
                    await this.fetchScheduledScanList({
                        client: this.getSelectedClient,
                        page: pageNumber,
                        page_size: itemsPerPage === 'All' ? this.getScheduledScanList.totalCount : itemsPerPage,
                        search_scan_name: search
                    });
                    this.loadingFetchScheduledScanList = false;
                } else if (type === 'compliance'){
                    this.loadingFetchScenarioScanList = true;
                    await this.fetchScenarioScanList({
                        client: this.getSelectedClient,
                        page: pageNumber,
                        page_size: itemsPerPage === 'All' ? this.getScenarioScanList.totalCount : itemsPerPage,
                        search_website_name: search
                    });
                    this.loadingFetchScenarioScanList = false;
                } else if (type === 'performance.realtime'){
                    this.loadingFetchRealTimeScanList = true;
                    await this.fetchRealTimeScanList({
                        client: this.getSelectedClient,
                        page: pageNumber,
                        page_size: itemsPerPage === 'All' ? this.getRealTimeScanList.totalCount : itemsPerPage,
                        search_scan_name: search
                    });
                    this.loadingFetchRealTimeScanList = false;
                }
            },
            async handlePagination(itemsPerPage, type, pageNumber, search){
                if(type === 'performance.scheduled'){
                    this.loadingFetchScheduledScanList = true;
                    await this.fetchScheduledScanList({
                        client: this.getSelectedClient,
                        page: pageNumber,
                        page_size: itemsPerPage === 'All' ? this.getScheduledScanList.totalCount : itemsPerPage,
                        search_scan_name: search
                    });
                    this.loadingFetchScheduledScanList = false;
                } else if (type === 'compliance'){
                    this.loadingFetchScenarioScanList = true;
                    await this.fetchScenarioScanList({
                        client: this.getSelectedClient,
                        page: pageNumber,
                        page_size: itemsPerPage === 'All' ? this.getScenarioScanList.totalCount : itemsPerPage,
                        search_website_name: search
                    });
                    this.loadingFetchScenarioScanList = false;
                } else if (type === 'performance.realtime'){
                    this.loadingFetchRealTimeScanList = true;
                    await this.fetchRealTimeScanList({
                        client: this.getSelectedClient,
                        page: pageNumber,
                        page_size: itemsPerPage === 'All' ? this.getRealTimeScanList.totalCount : itemsPerPage,
                        search_scan_name: search
                    });
                    this.loadingFetchRealTimeScanList = false;
                }
            },
            async handleSearch (itemsPerPage, type, pageNumber, search){
                if(type === 'performance.scheduled'){
                    this.loadingFetchScheduledScanList = true;
                    await this.fetchScheduledScanList({
                        client: this.getSelectedClient,
                        page: pageNumber,
                        page_size: itemsPerPage === 'All' ? this.getScheduledScanList.totalCount : itemsPerPage,
                        search_scan_name: search
                    });
                    this.loadingFetchScheduledScanList = false;
                } else if (type === 'compliance'){
                    this.loadingFetchScenarioScanList = true;
                    await this.fetchScenarioScanList({
                        client: this.getSelectedClient,
                        page: pageNumber,
                        page_size: itemsPerPage === 'All' ? this.getScenarioScanList.totalCount : itemsPerPage,
                        search_website_name: search
                    });
                    this.loadingFetchScenarioScanList = false;
                } else if (type === 'performance.realtime'){
                    this.loadingFetchRealTimeScanList = true;
                    await this.fetchRealTimeScanList({
                        client: this.getSelectedClient,
                        page: pageNumber,
                        page_size: itemsPerPage === 'All' ? this.getRealTimeScanList.totalCount : itemsPerPage,
                        search_scan_name: search
                    });
                    this.loadingFetchRealTimeScanList = false;
                }
            }
        },
        watch: {
            getSelectedClient: function() {
                this.loadScanListTableData();
            },
            scan: function(scan){
                if(this.domainType === 'scenario'){
                    this.confirmBody = `${scan.website.name}, ${scan.page.name}, ${scan.consent_type.name}`;
                } else {
                    this.confirmBody = `${scan.name}, ${scan.device.device}, ${scan.type}`;
                }
            },
            getPermissions: function(permissions){
                permissions.forEach(p =>{
                    if(p.name === 'general.compliance.scheduled_scan' ){
                        this.complianceLevel = p.level;
                        if(p.level === 'write'){
                            this.complianceLimit = p.limit_left
                        }
                        p.level === 'unlimited' || p.level === 'write' ? this.complianceEdit = true : false
                    } else if(p.name === 'general.performance.scheduled.scan') {
                        this.scheduledPerformanceLevel = p.level;
                        if(p.level === 'write'){
                            this.scheduledPerformanceLimit = p.limit_left
                        }
                        p.level === 'unlimited' || p.level === 'write' ? this.scheduledPerformanceEdit = true : false
                    } else if(p.name === 'general.performance.scheduled.ads') {
                        this.scheduledAdsLevel= p.level;
                        if(p.level === 'write'){
                            this.scheduledAdsLimit = p.limit_left
                        }
                        p.level === 'unlimited' || p.level === 'write' ? this.scheduledAdsEdit = true : false
                    } else if(p.name === 'general.performance.realtime.scan') {
                        this.realtimePerformanceLevel = p.level;
                        if(p.level === 'write'){
                            this.realtimePerformanceLimit = p.limit_left
                        }
                        p.level === 'unlimited' || p.level === 'write' ? this.realtimePerformanceEdit = true : false
                    } else if(p.name === 'general.performance.realtime.ads') {
                        this.realtimeAdsLevel = p.level;
                        if(p.level === 'write'){
                            this.realtimeAdsLimit = p.limit_left
                        }
                        p.level === 'unlimited' || p.level === 'write' ? this.realtimeAdsEdit = true : false
                    }
                });
                switch (true) {
                    case this.scheduledPerformanceLevel === 'write' && this.scheduledPerformanceLimit === 0 &&  this.scheduledAdsLimit === 0:
                    case this.scheduledAdsLevel === 'write' &&  this.scheduledAdsLimit === 0 && this.scheduledPerformanceLimit === 0:
                    case this.scheduledPerformanceLevel === 'zeroed' && this.scheduledAdsLevel === 'zeroed':
                    case this.scheduledPerformanceLevel === 'read' && this.scheduledAdsLevel === 'read':
                    case this.scheduledPerformanceLevel === 'read'  && this.scheduledAdsLevel === 'zeroed':
                    case this.scheduledAdsLevel === 'read' && this.scheduledPerformanceLevel === 'zeroed':
                        this.isDisabledAddScheduledScan = true;
                        break;
                    default:
                        this.isDisabledAddScheduledScan = false;
                }
                if(this.scheduledPerformanceLevel === 'unlimited' || this.scheduledAdsLevel === 'unlimited'){
                    this.isDisabledAddScheduledScan = false
                }

                switch (true) {
                    case this.realtimePerformanceLevel === 'write' && this.realtimePerformanceLimit === 0 &&  this.realtimeAdsLimit === 0:
                    case this.realtimeAdsLevel === 'write' &&  this.realtimeAdsLimit === 0 && this.realtimePerformanceLimit === 0:
                    case this.realtimePerformanceLevel === 'zeroed' && this.realtimeAdsLevel === 'zeroed':
                    case this.realtimePerformanceLevel === 'read' && this.realtimeAdsLevel === 'read':
                    case this.realtimePerformanceLevel === 'read'  && this.realtimeAdsLevel === 'zeroed':
                    case this.realtimeAdsLevel === 'read' && this.realtimePerformanceLevel === 'zeroed':
                        this.isDisabledAddRealtimeScan = true;
                        break;
                    default:
                        this.isDisabledAddRealtimeScan = false;
                }

                if(this.realtimePerformanceLevel === 'unlimited' || this.realtimeAdsLevel === 'unlimited'){
                    this.isDisabledAddRealtimeScan = false
                }

                switch (true) {
                    case this.complianceLevel === 'write' && this.complianceLimit === 0:
                    case this.complianceLevel === 'read':
                    case this.complianceLevel === 'zeroed':
                        this.isDisabledAddComplianceScan = true;
                        break;
                    default:
                        this.isDisabledAddComplianceScan = false;
                }
            }
        },
        created() {
            this.loadScanListTableData();
        },
        data(){
            return {
                dialog: false,
                scan: {},
                confirmBody: '',
                domainType: '',
                selectedScan: '',
                openOnClick: false,
                scheduledPerformanceLimit: 0,
                scheduledAdsLimit: 0,
                realtimePerformanceLimit: 0,
                realtimeAdsLimit: 0,
                complianceLimit: 0,
                scheduledPerformanceLevel: '',
                scheduledAdsLevel: '',
                realtimePerformanceLevel: '',
                realtimeAdsLevel: '',
                complianceLevel: '',
                isDisabledAddScheduledScan: false,
                isDisabledAddRealtimeScan: false,
                isDisabledAddComplianceScan: false,
                complianceEdit: false,
                scheduledPerformanceEdit: false,
                scheduledAdsEdit: false,
                realtimePerformanceEdit: false,
                realtimeAdsEdit: false,

                isScheduledPerformanceAvailable: false,
                isScheduledAdsAvailable: false,
                isRealtimePerformanceAvailable: false,
                isRealtimeAdsAvailable: false,
                isComplianceAvailable: false,

                loadingFetchScheduledScanList: false,
                loadingFetchScenarioScanList: false,
                loadingFetchRealTimeScanList: false,
            }
        }
    };
</script>
